import Aside from "../../components/aside";
import Navigator from "../../components/common/Navigator";
import {useNavigate, useParams} from "react-router-dom";
import DashBoard from "../dash_board";
import MediaManage from "../media_manage";
import PlatformManage from "../platform_manage";
import Reports from "../reports";
import Account from "../account_manage";
import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {useAtom} from "jotai";
import {selUserByUserId} from "../../services/platform/ManageUserAxios";
import {logOutAdmin, logOutUser} from "../../services/auth/AuthAxios";
import Customer from "../customer";
import ApiGuide from "../api_guide";
import ApiGuideTest from "../api_guide/ApiTest";
import {
  adminInfoAtom,
  authStatusAtom,
  tokenResultAtom,
  userInfoAtom,
} from "../../store";

export const AdminInfo = adminInfoAtom;
export const UserInfo = userInfoAtom;

function Layout() {
  const params = useParams();
  const navigate = useNavigate();
  const userMenuRef = useRef(null);
  const notificationRef = useRef(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const notifications = [];
  const [readNoticeIds, setReadNoticeIds] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [adminInfoState, setAdminInfoState] = useAtom(AdminInfo);
  const [userInfoState, setUserInfoState] = useAtom(UserInfo);
  const [tokenUserInfo, setTokenUserInfo] = useAtom(tokenResultAtom);
  const [, setAuthStatus] = useAtom(authStatusAtom);

  useEffect(() => {
    if (adminInfoState.convertedUser) {
      selUserByUserId(adminInfoState.convertedUser).then(response => {
        setUserInfoState({
          name: response.managerName1,
          id: response.id,
        });
      });
    }
  }, [adminInfoState.convertedUser, setUserInfoState]);

  useEffect(() => {
    if (!isUserMenuOpen) {
      return undefined;
    }

    const closeMenu = event => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };
    const closeMenuWithEscape = event => {
      if (event.key === "Escape") {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", closeMenu);
    document.addEventListener("keydown", closeMenuWithEscape);

    return () => {
      document.removeEventListener("mousedown", closeMenu);
      document.removeEventListener("keydown", closeMenuWithEscape);
    };
  }, [isUserMenuOpen]);

  useEffect(() => {
    if (!isNotificationOpen) return undefined;
    const closeDropdown = event => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };
    const closeWithEscape = event => event.key === "Escape" && setIsNotificationOpen(false);
    document.addEventListener("mousedown", closeDropdown);
    document.addEventListener("keydown", closeWithEscape);
    return () => {
      document.removeEventListener("mousedown", closeDropdown);
      document.removeEventListener("keydown", closeWithEscape);
    };
  }, [isNotificationOpen]);

  const saveReadNotices=ids=>{
    const next=[...new Set(ids)];
    setReadNoticeIds(next);
    localStorage.setItem(`media-read-notices-${tokenUserInfo.id||tokenUserInfo.username||"user"}`,JSON.stringify(next));
  };
  const openNotification=notice=>{
    saveReadNotices([...readNoticeIds,notice.id]);
    setIsNotificationOpen(false);
    navigate("/board/noticeDetail",{state:{data:notice}});
  };
  const unreadCount=notifications.filter(item=>!readNoticeIds.includes(item.id)).length;

  const myPage = () => {
    setIsUserMenuOpen(false);
    if (tokenUserInfo.role === "NORMAL") {
      navigate("/board/myPageUser", {state: {id: userInfoState.id}});
    } else {
      navigate("/board/myPageAdmin", {state: {id: tokenUserInfo.id}});
    }
  };

  const apiGuide = () => {
    setIsUserMenuOpen(false);
    navigate("/board/apiGuide");
  };

  const logOut = () => {
    setIsUserMenuOpen(false);
    const userInfo = {
      accessToken: tokenUserInfo.accessToken,
      refreshToken: localStorage.getItem("refreshToken"),
    };
    const logoutRequest = tokenUserInfo.role === "NORMAL"
      ? logOutUser(userInfo)
      : logOutAdmin(userInfo);

    logoutRequest.finally(() => {
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("mediaUsername");
      setTokenUserInfo({
        accessToken: "",
        refreshToken: "",
        id: "",
        role: "",
        name: "",
        username: "",
        serverName: "",
      });
      setUserInfoState({
        email: "",
        name: "",
        id: "",
      });
      setAdminInfoState({
        email: "",
        name: "",
        convertedUser: "",
        id: "",
        accountProfile: "",
      });
      setAuthStatus("unauthenticated");
      navigate("/", {replace: true});
    });
  };

  const displayName = tokenUserInfo.name || tokenUserInfo.username || "사용자";
  const userInitial = displayName.trim().charAt(0).toUpperCase() || "U";
  const roleLabel = tokenUserInfo.role === "NORMAL" ? "매체사" : "관리자";
  const isMyPageActive = ["myPageAdmin", "myPageUser"].includes(params.id);
  const isApiGuideActive = params.id === "apiGuide";

  return (
    <LayoutContainer id="container">
      <Aside mobileOpen={isMobileMenuOpen} onNavigate={() => setIsMobileMenuOpen(false)}/>
      <MobileOverlay
        type="button"
        $open={isMobileMenuOpen}
        aria-label="메뉴 닫기"
        onClick={() => setIsMobileMenuOpen(false)}
      />
      <BoardBody>
        <BoardHeader>
          <HeaderInner>
            <HeaderLeftArea>
              <MobileMenuButton
                type="button"
                aria-label="전체 메뉴 열기"
                aria-expanded={isMobileMenuOpen}
                onClick={() => setIsMobileMenuOpen(true)}
              >
                <span/><span/><span/>
              </MobileMenuButton>
              <Navigator global/>
            </HeaderLeftArea>

            <HeaderRightArea>
              <NotificationContainer ref={notificationRef}>
                <NotificationButton type="button" $open={isNotificationOpen} aria-label="알림 확인" aria-expanded={isNotificationOpen}
                  onClick={()=>{setIsNotificationOpen(open=>!open);setIsUserMenuOpen(false);}}>
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6v-5a7 7 0 0 0-5.5-6.84V3a1.5 1.5 0 0 0-3 0v1.16A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Zm-12 .83V11a5 5 0 0 1 10 0v5.83l.17.17H6.83L7 16.83Z"/>
                  </svg>
                  {unreadCount>0&&<NotificationDot/>}
                </NotificationButton>
                {isNotificationOpen&&<NotificationDropdown>
                  <NotificationHeader>
                    <div><strong>알림</strong>{unreadCount>0&&<UnreadBadge>{unreadCount}</UnreadBadge>}<span>최근 알림을 확인하세요.</span></div>
                    {unreadCount>0&&<ReadAll type="button" onClick={()=>saveReadNotices([...readNoticeIds,...notifications.map(item=>item.id)])}>모두 읽음</ReadAll>}
                  </NotificationHeader>
                  <NotificationList>
                    {notifications.length?<>{notifications.map(notice=>{
                      const unread=!readNoticeIds.includes(notice.id);
                      return <NotificationItem type="button" key={notice.id} $unread={unread} onClick={()=>openNotification(notice)}>
                        <NoticeIcon $unread={unread}>N</NoticeIcon>
                        <NoticeText><strong>{notice.title}</strong><span>{notice.createdAt?.substring(0,16)?.replace("T"," ")||"공지사항"}</span></NoticeText>
                        {unread&&<UnreadDot/>}
                      </NotificationItem>;
                    })}</>:<NotificationEmpty><span>✓</span><strong>새로운 알림이 없습니다.</strong><p>등록된 알림이 여기에 표시됩니다.</p></NotificationEmpty>}
                  </NotificationList>
                  <NotificationFooter type="button" onClick={()=>{setIsNotificationOpen(false);}}>알림 전체 보기 <span>›</span></NotificationFooter>
                </NotificationDropdown>}
              </NotificationContainer>

              <UserMenuContainer ref={userMenuRef}>
              <UserMenuButton
                type="button"
                $open={isUserMenuOpen}
                $active={isMyPageActive}
                aria-haspopup="menu"
                aria-expanded={isUserMenuOpen}
                onClick={() => {setIsUserMenuOpen(open => !open);setIsNotificationOpen(false);}}
              >
                <UserAvatar>{userInitial}</UserAvatar>
                <ProfileUserInfo>
                  <UserName>{displayName}</UserName>
                  <UserRole>{roleLabel}</UserRole>
                </ProfileUserInfo>
                <ChevronIcon $open={isUserMenuOpen} viewBox="0 0 20 20" aria-hidden="true">
                  <path d="m5.5 7.5 4.5 4.5 4.5-4.5"/>
                </ChevronIcon>
              </UserMenuButton>

              {isUserMenuOpen && (
                <UserDropdown role="menu">
                  <DropdownSummary>
                    <DropdownAvatar>{userInitial}</DropdownAvatar>
                    <DropdownUserInfo>
                      <strong>{displayName}</strong>
                      <span>{roleLabel} 계정</span>
                    </DropdownUserInfo>
                  </DropdownSummary>
                  <DropdownDivider/>
                  <DropdownMenuButton type="button" role="menuitem" $active={isApiGuideActive} onClick={apiGuide}>
                    <MenuIcon>
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M14 5h5v5M19 5l-8 8M18 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/>
                      </svg>
                    </MenuIcon>
                    <MenuText>
                      <strong>API 연동 가이드</strong>
                      <span>광고 송출 API 연동 문서를 확인합니다</span>
                    </MenuText>
                    <MenuArrow>›</MenuArrow>
                  </DropdownMenuButton>
                  <DropdownMenuButton type="button" role="menuitem" $active={isMyPageActive} onClick={myPage}>
                    <MenuIcon>
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="8" r="3.5"/>
                        <path d="M5.5 19c.7-3.3 3.1-5 6.5-5s5.8 1.7 6.5 5"/>
                      </svg>
                    </MenuIcon>
                    <MenuText>
                      <strong>마이페이지</strong>
                      <span>계정 정보를 확인하고 관리합니다</span>
                    </MenuText>
                    <MenuArrow>›</MenuArrow>
                  </DropdownMenuButton>
                  <DropdownDivider/>
                  <LogoutButton type="button" role="menuitem" onClick={logOut}>
                    <MenuIcon>
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4M14 8l4 4-4 4M18 12H9"/>
                      </svg>
                    </MenuIcon>
                    <MenuText>
                      <strong>로그아웃</strong>
                      <span>현재 계정에서 안전하게 나갑니다</span>
                    </MenuText>
                  </LogoutButton>
                </UserDropdown>
              )}
              </UserMenuContainer>
            </HeaderRightArea>
          </HeaderInner>
        </BoardHeader>

        <BoardContent>
          {params.id === "dashboard" && <DashBoard/>}
          {["media", "mediaList", "mediaListDetail"].includes(params.id) && <MediaManage/>}
          {["reports", "reportsHour", "reportsMedia", "reportsInventory", "reportsAdExchange"].includes(params.id) && <Reports/>}
          {["account", "accountHistory", "accountProfile", "accountConfirm", "accountData"].includes(params.id) && <Account/>}
          {[
            "platform",
            "platformUserDetail",
            "platformAdmin",
            "platformTerm",
            "platformTermDetail",
            "platformCategory",
            "platformHistory",
            "platformAdExchange",
            "platformHistoryDetail",
            "platformAdExchangeDetail",
            "myPageUser",
            "myPageAdmin",
          ].includes(params.id) && <PlatformManage/>}
          {["notice", "noticeDetail", "inquiry", "inquiryDetail"].includes(params.id) && <Customer/>}
          {params.id === "apiGuide" && <ApiGuide/>}
          {params.id === "apiTest" && <ApiGuideTest/>}
        </BoardContent>
      </BoardBody>
    </LayoutContainer>
  );
}

export default Layout;

const LayoutContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f5f6f8;
`;

const BoardBody = styled.main`
  flex: 1;
  width: 0;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: #f5f6f8;
`;

const BoardHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 64px;
  border-bottom: 1px solid #e8eaed;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 1px 3px rgba(18, 24, 33, 0.04);
  backdrop-filter: blur(10px);
`;

const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 14px;
  }
`;

const HeaderLeftArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  overflow: hidden;
`;

const MobileMenuButton = styled.button`
  display: none;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-surface);

  span {
    width: 15px;
    height: 1.5px;
    border-radius: 2px;
    background: #4b5563;
  }

  &:hover {
    border-color: var(--color-primary-border);
    background: var(--color-primary-soft);
  }

  @media (max-width: 960px) {
    display: inline-flex;
  }
`;

const MobileOverlay = styled.button`
  position: fixed;
  inset: 0;
  z-index: 210;
  display: ${({$open}) => ($open ? "block" : "none")};
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(15, 23, 42, .46);
`;

const HeaderRightArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const NotificationContainer=styled.div`position:relative;flex:0 0 auto;`;
const NotificationButton = styled.button`
  position: relative;
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid ${({$open})=>$open?"var(--color-primary-focus)":"var(--color-border)"};
  border-radius: 50%;
  background: ${({$open})=>$open?"var(--color-primary-soft)":"var(--color-surface)"};
  color: ${({$open,theme})=>$open?theme.color.subColor:"#5f6770"};
  transition: border-color .16s ease, background .16s ease, color .16s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    border-color: var(--color-primary-border);
    background: var(--color-primary-soft);
    color: ${({theme}) => theme.color.subColor};
  }
`;

const NotificationDot = styled.span`
  position: absolute;
  top: 7px;
  right: 7px;
  width: 7px;
  height: 7px;
  border: 2px solid var(--color-surface);
  border-radius: 50%;
  background: ${({theme}) => theme.color.subColor};
`;
const NotificationDropdown=styled.div`
  position:absolute;top:calc(100% + 10px);right:0;z-index:125;width:360px;overflow:hidden;border:1px solid #e2e7ec;border-radius:12px;background:var(--color-surface);
  box-shadow:0 16px 42px rgba(22,30,42,.16);
  &::before{position:absolute;top:-6px;right:14px;width:10px;height:10px;border-top:1px solid #e2e7ec;border-left:1px solid #e2e7ec;background:var(--color-surface);content:"";transform:rotate(45deg);}
  @media(max-width:600px){position:fixed;top:58px;right:10px;width:calc(100vw - 20px);}
`;
const NotificationHeader=styled.div`
  display:flex;align-items:center;justify-content:space-between;min-height:34px;padding:10px 17px;border-bottom:1px solid var(--color-divider);background:linear-gradient(135deg,var(--color-surface) 0%,#f5f9ff 100%);
  >div{display:flex;grid-template-columns:auto auto 1fr;justify-content:space-between;align-items:center;column-gap:7px;}strong{color:#252b33;font-size: var(--font-size-16);font-weight:800;}div>span:last-child{grid-column:1/4;margin-top:5px;color:#8a939d;font-size: var(--font-size-11);}
`;
const UnreadBadge=styled.b`display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 6px;border-radius:10px;background:var(--color-primary-strong);color:var(--color-surface);font-size: var(--font-size-11);`;
const ReadAll=styled.button`padding:6px 8px;border:0;background:transparent;color:var(--color-primary-strong);font-size: var(--font-size-11);font-weight:700;&:hover{text-decoration:underline;}`;
const NotificationList=styled.div`max-height:350px;overflow-y:auto;`;
const NotificationItem=styled.button`
  position:relative;display:grid;grid-template-columns:36px minmax(0,1fr) 8px;align-items:center;gap:11px;width:100%;min-height:66px;padding:11px 16px;border:0;border-bottom:1px solid #f0f2f4;
  background:${({$unread})=>$unread?"#f7fbff":"var(--color-surface)"};text-align:left;&:hover{background:var(--color-primary-soft);}
`;
const NoticeIcon=styled.span`
  display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:10px;background:${({$unread})=>$unread?"var(--color-primary-muted)":"#f0f2f4"};
  color:${({$unread})=>$unread?"var(--color-primary-strong)":"#89929c"};font-size: var(--font-size-14);font-weight:850;
`;
const NoticeText=styled.span`
  display:flex;min-width:0;flex-direction:column;gap:5px;strong{overflow:hidden;color:#333a44;font-size: var(--font-size-13);font-weight:700;text-overflow:ellipsis;white-space:nowrap;}
  span{color:#929aa4;font-size: var(--font-size-11);}
`;
const UnreadDot=styled.i`width:6px;height:6px;border-radius:50%;background:var(--color-primary-strong);`;
const NotificationEmpty=styled.div`
  display:flex;min-height:175px;align-items:center;justify-content:center;flex-direction:column;color:#929ba5;
  span{display:flex;width:38px;height:38px;align-items:center;justify-content:center;margin-bottom:10px;border-radius:50%;background:#f0f4f8;color:#7f8b98;}
  strong{color:#626c77;font-size: var(--font-size-13);}p{margin:5px 0 0;font-size: var(--font-size-11);}
`;
const NotificationFooter=styled.button`
  display:flex;align-items:center;justify-content:center;gap:6px;width:100%;height:43px;border:0;border-top:1px solid #e9edf1;background:var(--color-surface);color:#4f5965;font-size: var(--font-size-12);font-weight:700;
  span{color:var(--color-primary-strong);font-size: var(--font-size-18);}&:hover{background:#f7faff;color:var(--color-primary-strong);}
`;

const UserMenuContainer = styled.div`
  position: relative;
  flex: 0 0 auto;
`;

const UserMenuButton = styled.button`
  display: flex;
  align-items: center;
  min-width: 174px;
  min-height: 46px;
  padding: 5px 10px 5px 6px;
  border: 1px solid ${({$open, $active}) => ($open || $active ? "var(--color-primary-focus)" : "var(--color-border)")};
  border-radius: 9px;
  background: ${({$open, $active}) => ($open || $active ? "var(--color-primary-soft)" : "transparent")};
  text-align: left;
  transition: border-color 0.18s ease, background 0.18s ease;

  &:hover {
    background: #f4f7fb;
  }

  &:focus-visible {
    outline: 2px solid ${({theme}) => theme.color.subColor};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    min-width: auto;
    padding-right: 7px;
  }
`;

const UserAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #eaf3ff;
  color: ${({theme}) => theme.color.subColor};
  font-size: var(--font-size-16);
  font-weight: 800;
`;

const ProfileUserInfo = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  margin: 0 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const UserName = styled.strong`
  overflow: hidden;
  color: #303640;
  font-size: var(--font-size-15);
  font-weight: 700;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UserRole = styled.span`
  color: #8b939f;
  font-size: var(--font-size-13);
  line-height: 1.35;
`;

const ChevronIcon = styled.svg`
  width: 20px;
  height: 20px;
  padding: 4px;
  border: 1px solid ${({$open}) => ($open ? "var(--color-primary-border)" : "#e2e6ea")};
  border-radius: 50%;
  background: ${({$open}) => ($open ? "var(--color-primary-muted)" : "#f7f8fa")};
  fill: none;
  stroke: ${({$open, theme}) => ($open ? theme.color.subColor : "#77808d")};
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  transform: rotate(${({$open}) => ($open ? "180deg" : "0deg")});
  transition: transform 0.18s ease;
`;

const UserDropdown = styled.div`
  position: absolute;
  top: calc(100% + 9px);
  right: 0;
  z-index: 120;
  width: 270px;
  padding: 8px;
  border: 1px solid #e3e7ec;
  border-radius: 12px;
  background: var(--color-surface);
  box-shadow: 0 14px 38px rgba(22, 30, 42, 0.14);

  &::before {
    position: absolute;
    top: -6px;
    right: 22px;
    width: 10px;
    height: 10px;
    border-top: 1px solid #e3e7ec;
    border-left: 1px solid #e3e7ec;
    background: var(--color-surface);
    content: "";
    transform: rotate(45deg);
  }

  @media (max-width: 768px) {
    position: fixed;
    top: 58px;
    right: 12px;
  }
`;

const DropdownSummary = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
`;

const DropdownAvatar = styled(UserAvatar)`
  flex-basis: 38px;
  width: 38px;
  height: 38px;
`;

const DropdownUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-left: 10px;

  strong {
    overflow: hidden;
    color: #272d36;
    font-size: var(--font-size-15);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    margin-top: 2px;
    color: #8b939f;
    font-size: var(--font-size-13);
  }
`;

const DropdownDivider = styled.div`
  height: 1px;
  margin: 4px 6px;
  background: var(--color-divider);
`;

const MenuIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #667180;

  svg {
    width: 17px;
    height: 17px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.7;
  }
`;

const MenuText = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong {
    color: #343b45;
    font-size: var(--font-size-14);
    font-weight: 700;
    line-height: 1.45;
  }

  span {
    overflow: hidden;
    color: #929aa5;
    font-size: var(--font-size-12);
    line-height: 1.4;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const MenuArrow = styled.span`
  color: #9ba3ae;
  font-size: var(--font-size-19);
  text-align: center;
`;

const DropdownMenuButton = styled.button`
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 52px;
  padding: 7px 8px;
  border: 0;
  border-radius: 8px;
  background: ${({$active}) => ($active ? "var(--color-primary-soft)" : "transparent")};
  text-align: left;
  transition: background 0.16s ease;

  &:hover {
    background: var(--color-primary-soft);

    ${MenuIcon} {
      background: var(--color-primary-muted);
      color: ${({theme}) => theme.color.subColor};
    }

    ${MenuText} strong,
    ${MenuArrow} {
      color: ${({theme}) => theme.color.subColor};
    }
  }

  &:focus-visible {
    outline: 2px solid ${({theme}) => theme.color.subColor};
    outline-offset: -2px;
  }
`;

const LogoutButton = styled(DropdownMenuButton)`
  grid-template-columns: 30px minmax(0, 1fr);

  &:hover {
    background: #fff3f3;

    ${MenuIcon} {
      background: #ffe4e4;
      color: #d85a5a;
    }

    ${MenuText} strong {
      color: #c94e4e;
    }
  }
`;

const BoardContent = styled.div`
  min-height: calc(100vh - 64px);
  background: #f5f6f8;
`;
